<template>
  <div class="row py-3 mx-0 bg-secondary-3 rounded">
    <div class="col-md-2">
     <div class="row ml-4 border-right">  
      <div class="col-12 pb-3">
        <span class="color-gray font-weight-normal font-14">Estudiante:</span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.studentName }} 
        </div>
      </div>
      <div class="col-12 pb-3">
        <span class="color-gray font-weight-normal font-14">SIE:</span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.studentSieId }}
        </div>
      </div>
     </div>
    </div>
   
    <div class="col-md-10">
      <div class="row ml-4">
        <div class="col-sm-6 col-md-3 pb-3">
          <span class="color-gray font-weight-normal font-14">Edad:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.age }} años
          </div>
        </div>
        <div class="col-sm-6 col-md-3 pb-3">
          <span class="color-gray font-weight-normal font-14">Grupo Étnico:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.ethnicity }}
          </div>
        </div>
        <div class="col-sm-6 col-md-2 pb-3">
          <span class="color-gray font-weight-normal font-14">Género:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.gender }}        
          </div>
        </div>
        <div class="col-sm-6 col-md-4 pb-3">
          <span class="color-gray font-weight-normal font-14">Impedimento:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.disability }}        
          </div>
        </div>  
        <div class="col-sm-6 col-md-3 pb-3">
          <span class="color-gray font-weight-normal font-14">Aprendices del Español:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.langProficiency }}        
          </div>
        </div>   
        <div class="col-sm-6 col-md-6 pb-3">
          <span class="color-gray font-weight-normal font-14">Tipo de Remoción Disciplinaria:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.disciplineType }}        
          </div>
        </div>    
      </div>    
    </div>   
  </div>
</template>

<script>

export default {
  name: "ResultRowDetail",
  components: {

  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  }, 
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .border-right {
    border-right: unset !important;  
    border-bottom: 1px solid #dee2e6 !important;  
  }
}

</style>
